import { Flex } from 'antd';
import styled from 'styled-components';

export const CauseContainer = styled(Flex).attrs({ vertical: true, gap: 16 })`
  margin-top: -16px;
  width: 488px;
  padding: 24px;
  background-color: #fff;
  transition: all ease 0.4s;
  &.identified {
    width: 768px;
  }
`;

export const Assistance = styled(Flex).attrs({
  vertical: true,
  gap: 16,
  align: 'center',
})`
  padding: 20px;
  background-color: #f4f9ec;
  p {
    margin: 0;
    color: ${(props) => props.theme.antd.colorPrimary};
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
  button {
    background-color: #fff !important;
  }
`;

export const Percentage = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  border-radius: 100%;
  width: 36px;
  height: 36px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;
  background-color: #e6e8f9;
  color: #6a63c2;
  &.level2 {
    background-color: #d3d8f2;
    color: #6a63c2;
  }
  &.level3 {
    background-color: #8181d3;
    color: #fff;
  }
  &.level4 {
    background-color: #6a63c2;
    color: #fff;
  }
  &.level5 {
    background-color: #4d488b;
    color: #fff;
  }
`;

export const CauseItem = styled(Flex).attrs({
  vertical: true,
  gap: 8,
})`
  background-color: #f7f7f7;
  padding: 8px;
  cursor: pointer;
  .title {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: #334423;
  }
`;

export const ResultContainer = styled(Flex).attrs({
  vertical: true,
  flex: 1,
  align: 'center',
})`
  margin-top: 8px;
  padding: 20px;
  border: 1px solid #ececed;
  .icon {
  }
  p {
    text-align: center;
    margin: 16px 0 24px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: #334423;
  }
`;
